"use client";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
import n from "clsx";
import { isValidElement as r, useId as i, useState as a } from "react";
import { Tooltip as o } from "@base-ui/react/tooltip";
//#region src/components/tooltip/Tooltip.tsx
var s = ({ trigger: s, content: c, title: l, shortcut: u, side: d = "top", align: f = "center", showArrow: p = !1, trackCursor: m = !1, sideOffset: h = p ? 11 : 6, disabled: g, portalContainer: _, open: v, defaultOpen: y = !1, onOpenChange: b }) => {
	let x = i(), [S, C] = a(y), w = !g && (v ?? S), T = r(s) ? s.props["aria-describedby"] : void 0;
	return /* @__PURE__ */ t(o.Root, {
		trackCursorAxis: m ? "both" : "none",
		open: w,
		onOpenChange: (e) => {
			C(e), b?.(e);
		},
		disabled: g,
		children: [/* @__PURE__ */ e(o.Trigger, {
			render: s,
			delay: 100,
			closeDelay: 100,
			"aria-describedby": [T, w ? x : void 0].filter(Boolean).join(" ") || void 0
		}), /* @__PURE__ */ e(o.Portal, {
			container: _,
			children: /* @__PURE__ */ e(o.Positioner, {
				side: d,
				align: f,
				sideOffset: h,
				className: "pf-control-positioner pf:z-[60]",
				children: /* @__PURE__ */ t(o.Popup, {
					id: x,
					role: "tooltip",
					className: n("pf-control-tooltip pf:box-border pf:flex pf:flex-col pf:gap-xxs pf:rounded-sm pf:px-lg pf:py-md", "pf:bg-soft-pearl-1000 pf:text-background pf:font-body pf:text-copy-12 pf:wrap-anywhere pf:shadow-menu", "pf:transition-[opacity,transform] pf:duration-(--pf-duration-fast) pf:ease-(--pf-easing-out) pf:origin-(--transform-origin) pf:data-instant:transition-none pf:data-[starting-style]:opacity-0 pf:data-[ending-style]:opacity-0 pf:data-[ending-style]:duration-(--pf-duration-instant)", "pf:data-[side=top]:[--pf-tooltip-offset:0_4px] pf:data-[side=bottom]:[--pf-tooltip-offset:0_-4px] pf:data-[side=left]:[--pf-tooltip-offset:4px_0] pf:data-[side=right]:[--pf-tooltip-offset:-4px_0] pf:motion-safe:data-[starting-style]:[transform:translateY(4px)_scale(0.97)] pf:motion-safe:data-[ending-style]:[transform:scale(0.98)] pf:motion-reduce:transition-opacity", "pf:max-w-[min(240px,calc(100vw-24px))]"),
					children: [
						l && /* @__PURE__ */ t("span", {
							className: "pf:font-semibold",
							children: [l, " "]
						}),
						/* @__PURE__ */ t("span", {
							className: "pf:flex pf:items-center pf:gap-md",
							children: [
								/* @__PURE__ */ e("span", {
									className: "pf:min-w-0",
									children: c
								}),
								u ? " " : null,
								u && /* @__PURE__ */ e("kbd", {
									className: "pf:shrink-0 pf:rounded-xs pf:bg-soft-pearl-900 pf:px-xs pf:font-body pf:text-label-12 pf:text-soft-pearl-100",
									children: u
								})
							]
						}),
						p && /* @__PURE__ */ e(o.Arrow, {
							className: "pf:absolute pf:data-[side=top]:bottom-[-5px] pf:data-[side=bottom]:top-[-5px] pf:data-[side=bottom]:rotate-180 pf:data-[side=left]:right-[-7px] pf:data-[side=left]:-rotate-90 pf:data-[side=right]:left-[-7px] pf:data-[side=right]:rotate-90",
							children: /* @__PURE__ */ e("svg", {
								className: "pf:block",
								width: "10",
								height: "5",
								viewBox: "0 0 10 5",
								"aria-hidden": "true",
								children: /* @__PURE__ */ e("path", {
									d: "M0 0H10L5 5L0 0Z",
									fill: "currentColor",
									className: "pf:text-soft-pearl-1000"
								})
							})
						})
					]
				})
			})
		})]
	});
};
//#endregion
export { s as Tooltip };
